// @core/api/endpoints/signature/list_signatures_by_target.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSignaturesResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * List signatures of a target
 * Returns all signature evidence records attached to the given polymorphic target. Ordered by created_at ascending — earliest signature first.
 */
export async function ListSignaturesByTarget(
  target_type: string,
  target_id: string,
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListSignaturesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/targets/:target_type/:target_id/signatures`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListSignaturesResponse>(requestPath, { ...requestOptions, params });
}
